import "./styles/index.scss";
import { useRoutes, type RouteObject } from "react-router-dom";
import { routes } from "router";
import { ConfigProvider } from "antd";
import viVN from "antd/locale/vi_VN";
import { observer } from "mobx-react";
import { themeSettings } from "themeSettings";

const App = observer(() => {
  const element = useRoutes(routes as RouteObject[]);

  return (
    <ConfigProvider
      locale={viVN}
      theme={{
        token: themeSettings,
        hashed: false,
      }}
    >
      <div className="App app-ant-design-system">{element}</div>
    </ConfigProvider>
  );
});

export default App;
